import { get, set, del, keys } from "idb-keyval"

const prefix = "note-draft-"

export async function saveDraft(noteId, draft) {
  if (!noteId) return
  await set(`${prefix}${noteId}`, { draft, savedAt: Date.now() })
}

export async function loadDraft(noteId) {
  if (!noteId) return null
  const row = await get(`${prefix}${noteId}`)
  return row?.draft ?? null
}

export async function clearDraft(noteId) {
  if (!noteId) return
  await del(`${prefix}${noteId}`)
}

export async function syncPendingDrafts(apiPatch) {
  const allKeys = await keys()
  const draftKeys = allKeys.filter((k) => String(k).startsWith(prefix))
  for (const key of draftKeys) {
    const noteId = String(key).slice(prefix.length)
    const row = await get(key)
    if (row?.draft) {
      try {
        await apiPatch(noteId, row.draft)
        await del(key)
      } catch {
        /* retry later */
      }
    }
  }
}
